export default __webpack_public_path__ + "static/Novacom-ISO-27001-2022-Certificate-2025-5ea6db8d171975fbae9b4d89e13f2a16.pdf";